import { EnumDeviceType } from "ambiente/ambiente-tipos";
import { validaGuid } from "./valida-guid";
import { VariaveisAmbiente } from "ambiente";


export const getIDFromUrl = (type: 'mesaId' | 'empresaId' | 'pedidoId' = 'empresaId') => {
    const pathname = window.location.pathname;
    const hash = window.location.hash;
    const isCordova = VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA
    const url = isCordova ? hash : pathname;
    switch (type) {
        case 'empresaId':
            const guidEmpresa = url.split('/').find(x => validaGuid(x)) || ''
            return guidEmpresa;
        case 'pedidoId':
            {
                const parts = url.split('/').filter(Boolean);
                const pedidoIndex = parts.findIndex((x) => x.toLowerCase() === 'pedido');
                if (pedidoIndex >= 0 && parts[pedidoIndex + 1] && validaGuid(parts[pedidoIndex + 1])) {
                    return parts[pedidoIndex + 1];
                }
                return '';
            }
        default:
            let checks = 0;
            if (url.includes('pedido')) return ''
            return url.split('/').find(x => {
                if (validaGuid(x)) {
                    if (checks > 0) {
                        return true;
                    }
                    checks++;
                }
                return false;
            }) || ''
    }
}